import Vue from 'vue'
import PackageTransformer from '../../transformers/extranet/PackageTransformer'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

const fetchCostomerpackege = (param = { status: 'redy-for-custom' }) => {
  let config = null
  if (param) {
    config = {
      params: param,
    }
  }
  return Vue.$http.get('extranet/package/', config)
    .then(response => PackageTransformer.fetchCollection(response.data))
    .catch((err) => { throw err })
}

export default fetchCostomerpackege



// WEBPACK FOOTER //
// ./src/services/extranet/fetchCostomerpackege.js